export default __webpack_public_path__ + "static/media/userDemo.cf3abaac.png";